import { GlobalHelperFunctions } from '../../../../utils/GlobalHelperFunctions';
import './style.scss';

export default class VNextCertificatesPanel extends UIObject {
  mDiv: JQuery<HTMLElement>;
  container: JQuery<HTMLElement>;
  timeCreated: number;
  mData: any;
  mSubNavigation: any;

  private _constructorParams: any;
  constructor() {
    super();
  }

  initialize(aConstructorParams: any) {
    this._constructorParams = aConstructorParams;
    this.mDiv = this._generateHtml();
    this.container = aConstructorParams.container;
    this.container.prepend(this.mDiv);
    this._buildSettings();
    this.setupSubNav();
  }

  private _generateHtml(): JQuery<HTMLElement> {
    return $(
      HGEN.tree({
        id: 'vnext_certificates_panel',
        children: [
          { style: 'subnav_container ui_full_width subnav-font-family' },
          {
            id: 'juno_certificates',
            style: 'vnext_certificates_container',
          },
        ],
      }),
    );
  }
  private _buildSettings(): void {
    const { lessonSlug, courseSlug, tabSlug } = this._constructorParams.urlParams || {};
    const routeKey = App.INSTANCE?.mPathObject.as;
    /* Leon doesn't know what this was for
    window.onpopstate = function (e) {
      // need to manually reload when back button is pressed to the initial state
      if (e.state.idx === 0) {
        location.reload();
      }
    };
    */
    const defaultWidgetProps = App.INSTANCE.defaultVNextWidgetProps();

    this.timeCreated = Date.now();
    this.mData = {
      ...this._constructorParams.data,
      // todo: pare down this config object to just a theme
      ...defaultWidgetProps,
      pageSlug: 'courses',
      routeKey,
      courseSlug,
      lessonSlug,
      tabSlug,
      FETActions: [],
    };

    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    window.JunoWidgetSettings.widgets.push({
      siteId: CrowdHub_App.CONFIG.VNEXT_SITE_ID,
      widget: 'juno_certificates',
      mount: 'juno_certificates',
      data: this.mData,
      timeCreated: this.timeCreated,
    });

    const newScript = document.createElement('script');
    newScript.src = CrowdHub_App.CONFIG.VNEXT_WIDGET_SCRIPT_SRC || `https://widgets.junolive.dev/junoWidgets.js`;
    this.mDiv.append(newScript);
  }

  private setupSubNav(): void {
    if (this.mData.showSubNav == true && this.mData.subNavItems != null && this.mData.subNavItems.length > 0) {
      this.mSubNavigation = new CustomSubNavigation();
      this.mSubNavigation.initialize({ items: this.mData.subNavItems, div: this.mDiv.find('.subnav_container') });
    }
  }

  onTransitionIn(): void {
    $('#background_container').hide();
  }

  onTransitionOut(): void {
    const widgetKey = 'juno_certificates';
    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    const matchesWidget = widget => widget.widget === widgetKey && widget.timeCreated === this.timeCreated;
    const selectedWidget = window.JunoWidgetSettings.widgets.find(widget => matchesWidget(widget));
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets.filter(widget => !matchesWidget(widget));
    selectedWidget?.reactRoot?.unmount();
    $('#background_container').show();
  }
}
